// extracted by mini-css-extract-plugin
export default {"heading":"_37nbiTPcYsmcX2vfU0Aq0C","count":"_3YSNKRpkeKWwKpca4hI2y5","container":"_2FxzAifsP1ZEirQYFTbuWJ","button":"_6M0ftYESLPtcdVbcfcHGqF"};